import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { SLINKY } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
const FooterWrapper = styled.div.withConfig({
  displayName: "FooterMicrocopy__FooterWrapper",
  componentId: "sc-73kari-0"
})(["position:relative;padding-top:16px;padding-bottom:20px;z-index:1;color:", ";font-size:12px;clear:both;", ""], SLINKY, breakpoint.tablet(_t || (_t = _`
    padding-top: 50px;
    padding-left: 25px;
    padding-right: 30px;
  `)));

const FooterMicrocopy = () => {
  const handleClickLink = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'product-services-catalog'
    });
  };

  return /*#__PURE__*/_jsx(FooterWrapper, {
    className: "text-center flex-column",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "pricingPage.productServicesCatalogPrompt_jsx",
      options: {
        onClick: handleClickLink
      },
      elements: {
        UILink
      }
    })
  });
};

export default FooterMicrocopy;